<script>
  import KayakListItem from '@/features/kayaks/offers/presentation/components/KayakOfferListItem'
  export default {
    name: 'kayak-offers',
    components: {
      KayakListItem,
    },
    data () {
      return {
        items: []
      }
    },
    methods: {
      getKayaks() {
        var json = require('@/assets/data/json/kayaks/offers/kayak-offers.json');
        this.items = json
      },
      sortKayaksByName(items) {
        items.sort(function(a, b) {
          var nameA = a.name.toUpperCase();
          var nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      },
      canShowKayaks() {
        return this.items.length > 0
      },
    },
    mounted () {
      this.getKayaks()
      this.sortKayaksByName(this.items)
    }
  }
</script>
<template>
  <b-container
    class="main-content mb-5"
    v-if="canShowKayaks()">
    <b-row>
      <kayak-list-item
        v-for="item in items"
        :key="item.id"
        :item="item">
      </kayak-list-item>
    </b-row>
  </b-container>
  <div v-else>
    <div class="work-in-progress">
      <div class="work-in-progress">
        <div class="center">
          <div class="content">
            Al momento non ci sono offerte. <br>Torna a visitare questa pagina nelle prossime settimane!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
